import type React from 'react';
import { Suspense as RS } from 'react';

/**
 *
 * This component extends the default react Suspense component and add capability to handle a null queryref in relay
 *
 */

type Props = {
  fallback: React.ReactNode;
  exists?: unknown;
  showFallback?: boolean;
  children: React.ReactNode;
  key?: string;
};

const Suspense = (props: Props) => {
  if (Object.prototype.hasOwnProperty.call(props, 'exists') && Boolean(props?.exists) === false)
    return <>{props?.fallback}</>;

  if (Object.prototype.hasOwnProperty.call(props, 'showFallback') && Boolean(props?.showFallback) === true)
    return <>{props?.fallback}</>;

  return (
    <RS key={props?.key} fallback={props.fallback}>
      {props.children}
    </RS>
  );
};

export default Suspense;
